"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invalidCuCodes = void 0;
exports.invalidCuCodes = [
    '0015',
    '0020',
    '0021',
    '0025',
    '0033',
    '0034',
    '0040',
    '0041',
    '0042',
    '0050',
    '0146',
    '0206',
    '0219',
    '0246',
    '0261',
    '0715',
    '0736',
    '0740',
    '0741',
    '0744',
    '0746',
    '0749',
    '0750',
    '0767',
    '0769',
];
